import {createContext} from "react";
import {initialOrganizationObj} from "./Organization"
import {IOrganizationAdvertiserLogin} from "../interfaces/IOrganizationAdvertiserLogin";

export interface IClientCredentials {
    clientKey: string;
    visibleSecret: string | null;
}

export type ISavedPartnersByOrg = {[orgId: string]: string[]};

export const OrganizationContext = createContext({
    organization: initialOrganizationObj,
    setOrganization: (organization: IOrganizationAdvertiserLogin) => {},
    clientCredentials: null as IClientCredentials | null,
    setClientCredentials: (credentials: IClientCredentials | null) => {},
    savedPartnersByOrg: {} as ISavedPartnersByOrg,
})

